// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".list-filter-search-container {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  margin-left: auto;\n}\n.search-field {\n  -webkit-box-flex: 1;\n      -ms-flex-positive: 1;\n          flex-grow: 1;\n  display: inline-block;\n}\n.search-clear {\n  color: var(--white);\n}\n.btn.btn-secondary.search-append-bg {\n  margin: 0;\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  background-color: var(--form-control-addon-bg) !important;\n}\n", ""]);
// Exports
module.exports = exports;
